export default function About() {
    return (
        <section
            id="about"
            className="px-5 lg:px-10 w-full flex flex-col lg:flex-row py-20 bg-orange-100 max-w-5xl mx-auto">
            
            <div className="flex-1 flex flex-col justify-center items-center gap-5 px-6">
                <h2 className="text-center text-orange-400 text-5xl font-bold">
                    About Us:
                </h2>
                <p className="text-center">
                    At Mela Software, we specialize in crafting custom software solutions tailored to meet your unique business needs. Our team of experienced developers and designers leverage cutting-edge technology to deliver high-quality applications that drive efficiency and growth.
                </p>
            </div>

            <div className="flex-1 flex justify-center items-center mt-6 lg:mt-0">
                <iframe
                    className="w-full h-64 sm:h-80 lg:h-96"
                    src="https://www.youtube.com/embed/Q4J35YKVZC4"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen>
                </iframe>
            </div>
            
        </section>
    );
}